import { useTranslation } from 'react-i18next'
import { SEO } from '@/components/SEO'
import { Hero } from '@/components/Hero'
import { Section } from '@/components/Section'

export function TermsPage() {
  const { t } = useTranslation()

  return (
    <>
      <SEO
        title={t('terms.metaTitle')}
        description={t('terms.metaDescription')}
        noIndex
      />

      <Hero
        title={t('terms.heroTitle')}
        size="sm"
      />

      <Section>
        <div className="mx-auto max-w-4xl">
          <div className="prose prose-lg max-w-none prose-headings:text-secondary-900 prose-p:text-secondary-600 prose-li:text-secondary-600">
            <p className="text-sm text-secondary-500">
              {t('terms.lastUpdated')}: January 1, 2026
            </p>

            <h2>1. {t('terms.section1Title')}</h2>
            <p>{t('terms.section1Text')}</p>

            <h2>2. {t('terms.section2Title')}</h2>
            <p>{t('terms.section2Text')}</p>

            <h2>3. {t('terms.section3Title')}</h2>
            <p>{t('terms.section3Text')}</p>

            <h2>4. {t('terms.section4Title')}</h2>
            <p>{t('terms.section4Text')}</p>

            <h2>5. {t('terms.section5Title')}</h2>
            <p>{t('terms.section5Text')}</p>

            <h2>6. {t('terms.section6Title')}</h2>
            <p>{t('terms.section6Text')}</p>

            <h2>7. {t('terms.section7Title')}</h2>
            <p>{t('terms.section7Text')}</p>

            <h2>8. {t('terms.section8Title')}</h2>
            <p>{t('terms.section8Text')}</p>

            <h2>9. {t('terms.section9Title')}</h2>
            <p>
              Chemical Newtech S.p.A.<br />
              Via Piemonte, 19<br />
              25031 Capriolo (BS), Italia<br />
              Email: info@chemicalnewtech.com<br />
              Tel: +39 030 7460669
            </p>
          </div>
        </div>
      </Section>
    </>
  )
}
